import { fetchConf } from '../api/api';
import { useQuery } from 'react-query';
import { useEffect, useState } from 'react';

export const useConfigQuery = () => {
    const [ enabled, setEnabled ] = useState(true);
    const { data, isLoading } = useQuery([], fetchConf, {enabled});
    const [ availableSportsBooks, setAvailableSportsBooks ] = useState([]);
    useEffect(() => {
        if (data) {
            setAvailableSportsBooks(data.books);
            setEnabled(false);
        }
    }, [data]);

    return { isLoading, availableSportsBooks };
}